import { ArrowDown, ArrowUp, Plus, Trash2, Upload } from "lucide-react";

export const MAX_INSTAGRAM_POSTS = 8;

// Editor das fotos da secção Instagram: imagem + link da publicação, até 8, por ordem.
// Não muta: cada alteração devolve uma lista nova através de onChange.
export default function InstagramPostsEditor({ posts = [], onChange, onUpload }) {
  const update = (index, changes) =>
    onChange(posts.map((post, i) => (i === index ? { ...post, ...changes } : post)));

  const remove = (index) => onChange(posts.filter((_, i) => i !== index));

  const move = (index, delta) => {
    const target = index + delta;
    if (target < 0 || target >= posts.length) return;
    const next = [...posts];
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  };

  const add = () => onChange([...posts, { image: "", url: "" }]);

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-2">
        <label className="block text-[#A1A1AA] text-xs">
          Fotos da secção ({posts.length}/{MAX_INSTAGRAM_POSTS}) — carrega a imagem e cola o link da publicação
        </label>
        {posts.length < MAX_INSTAGRAM_POSTS && (
          <button
            type="button"
            onClick={add}
            className="flex items-center gap-1 bg-[#3A3A3A] hover:bg-[#4A4A4A] text-[#F5F5F5] px-3 py-1 rounded text-xs"
            data-testid="instagram-add-post"
          >
            <Plus size={14} /> Adicionar foto
          </button>
        )}
      </div>

      {posts.length === 0 && (
        <p className="text-[#8A8A8A] text-xs">
          Sem fotos: no site aparece só o título e o botão “Seguir”.
        </p>
      )}

      <div className="grid sm:grid-cols-2 gap-3">
        {posts.map((post, index) => (
          <div key={index} className="flex gap-3 bg-[#141414] border border-[#3A3A3A] rounded p-2">
            <div className="w-20 h-20 flex-shrink-0 rounded overflow-hidden bg-[#1F1F1F] flex items-center justify-center">
              {post.image ? (
                <img src={post.image} alt={`Foto ${index + 1}`} className="w-full h-full object-cover" />
              ) : (
                <span className="text-[#8A8A8A] text-[10px] text-center px-1">Sem imagem</span>
              )}
            </div>
            <div className="flex-1 min-w-0 space-y-2">
              <div className="flex gap-2">
                <label className="flex items-center gap-1 bg-[#3A3A3A] hover:bg-[#4A4A4A] text-[#F5F5F5] px-2 py-1 rounded cursor-pointer text-xs">
                  <Upload size={14} /> Imagem
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => onUpload(e, (url) => update(index, { image: url }))}
                  />
                </label>
                <button type="button" onClick={() => move(index, -1)} disabled={index === 0} className="text-[#A1A1AA] hover:text-[#F5F5F5] disabled:opacity-30" aria-label="Subir">
                  <ArrowUp size={16} />
                </button>
                <button type="button" onClick={() => move(index, 1)} disabled={index === posts.length - 1} className="text-[#A1A1AA] hover:text-[#F5F5F5] disabled:opacity-30" aria-label="Descer">
                  <ArrowDown size={16} />
                </button>
                <button type="button" onClick={() => remove(index)} className="ml-auto text-red-400 hover:text-red-300" aria-label="Remover">
                  <Trash2 size={16} />
                </button>
              </div>
              <input
                value={post.url || ""}
                onChange={(e) => update(index, { url: e.target.value })}
                className="w-full bg-[#1F1F1F] border border-[#3A3A3A] rounded px-2 py-1 text-[#F5F5F5] text-xs"
                placeholder="https://www.instagram.com/p/... (vazio = abre o perfil)"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
